import { create } from 'zustand';

export interface AimSignalStateStore {
  newConditionId: string | null;
  setNewConditionId: (newConditionId: string | null) => void;
  isTailorManuallyClosed: boolean;
  setIsTailorManuallyClosed: (isTailorManuallyClosed: boolean) => void;
  hasExternalLinkBeenClicked: boolean;
  setHasExternalLinkBeenClicked: (hasExternalLinkBeenClicked: boolean) => void;
}

const defaultAimSignalState = {
  newConditionId: null,
  isTailorManuallyClosed: false,
  hasExternalLinkBeenClicked: false,
};

export const useAimSignalStateStore = create<AimSignalStateStore>((set) => ({
  ...defaultAimSignalState,
  setNewConditionId: (newConditionId: string | null) => set({ newConditionId }),
  setIsTailorManuallyClosed: (isTailorManuallyClosed: boolean) => set({ isTailorManuallyClosed }),
  setHasExternalLinkBeenClicked: (hasExternalLinkBeenClicked: boolean) => set({ hasExternalLinkBeenClicked }),
}));
